const state = {
  providers: [],
  user: {},
  user_list: [],
  user_list_network: [],
  networkChosen: false,
  rightPanelChosen: 'devices',
  leftPanelChosen: 'library',
  focused_side: 'left',
  ws_connected: 'false',
  liveMode: {
    heartbeat: false,
    contentUpdateProgress: false,
    contentPending: false,
    failedRequests: false,
    mediaConvertions: false,
    screenshots: true,
    library: false
  },
  package_version: '',
  csrfToken: '',
  axios_active_state: false,
  // axios_active_requests: new Set()
  changing_network_status_devices: undefined,
  changing_network_status_media: undefined
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/user/user.state.js
// module id = null
// module chunks = 